/**
 * DIFFY - Sincronizacao blindada das miniaturas da galeria mobile.
 * O slideshow do Horizon continua sendo o unico controlador das imagens.
 * Este arquivo apenas mantem a miniatura ativa visivel no trilho inferior.
 */
(function () {
  'use strict';

  if (window.__diffyGalleryThumbnailsInitialized) return;
  window.__diffyGalleryThumbnailsInitialized = true;

  var SELECTOR = '.media-gallery__mobile-controls[thumbnails]';
  var RAIL_SELECTOR = '.slideshow-controls__thumbnails-container';
  var THUMB_SELECTOR = '.slideshow-controls__thumbnail';

  var states = new WeakMap();
  var initialized = new WeakSet();

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getState(controls) {
    var state = states.get(controls);

    if (!state) {
      state = {
        rail: null,
        observer: null,
        animationFrame: 0,
        syncFrame: 0,
        releaseTimer: 0,
        interacting: false,
        pendingSync: false,
        listeners: null
      };
      states.set(controls, state);
    }

    return state;
  }

  function cancelAnimation(state) {
    if (state.animationFrame) {
      window.cancelAnimationFrame(state.animationFrame);
      state.animationFrame = 0;
    }
  }

  function clearReleaseTimer(state) {
    if (state.releaseTimer) {
      window.clearTimeout(state.releaseTimer);
      state.releaseTimer = 0;
    }
  }

  function finishInteraction(controls, delay) {
    var state = getState(controls);
    clearReleaseTimer(state);

    state.releaseTimer = window.setTimeout(function () {
      state.interacting = false;
      state.releaseTimer = 0;

      if (state.pendingSync) {
        state.pendingSync = false;
        scheduleSync(controls, true);
      }
    }, delay);
  }

  function unbindRail(controls) {
    var state = getState(controls);
    var listeners = state.listeners;

    if (state.rail && listeners) {
      state.rail.removeEventListener('pointerdown', listeners.start);
      state.rail.removeEventListener('pointerup', listeners.end);
      state.rail.removeEventListener('pointercancel', listeners.end);
      state.rail.removeEventListener('lostpointercapture', listeners.end);
      state.rail.removeEventListener('touchstart', listeners.start);
      state.rail.removeEventListener('touchend', listeners.end);
      state.rail.removeEventListener('touchcancel', listeners.end);
      state.rail.removeEventListener('scroll', listeners.scroll);
    }

    cancelAnimation(state);
    clearReleaseTimer(state);
    state.rail = null;
    state.listeners = null;
    state.interacting = false;
  }

  function bindRail(controls) {
    var state = getState(controls);
    var nextRail = controls.querySelector(RAIL_SELECTOR);

    if (state.rail === nextRail) return nextRail;
    unbindRail(controls);
    if (!nextRail) return null;

    var listeners = {};

    listeners.start = function () {
      clearReleaseTimer(state);
      cancelAnimation(state);
      state.interacting = true;
    };

    listeners.end = function () {
      /* A inercia do Safari continua depois que o dedo sai da tela. */
      finishInteraction(controls, 220);
    };

    listeners.scroll = function () {
      /* Um scroll manual ou inercial sempre tem prioridade sobre o auto-scroll. */
      if (state.interacting) {
        cancelAnimation(state);
        finishInteraction(controls, 140);
      }
    };

    nextRail.addEventListener('pointerdown', listeners.start, { passive: true });
    nextRail.addEventListener('pointerup', listeners.end, { passive: true });
    nextRail.addEventListener('pointercancel', listeners.end, { passive: true });
    nextRail.addEventListener('lostpointercapture', listeners.end, { passive: true });
    nextRail.addEventListener('touchstart', listeners.start, { passive: true });
    nextRail.addEventListener('touchend', listeners.end, { passive: true });
    nextRail.addEventListener('touchcancel', listeners.end, { passive: true });
    nextRail.addEventListener('scroll', listeners.scroll, { passive: true });

    state.rail = nextRail;
    state.listeners = listeners;
    return nextRail;
  }

  function animateTo(state, target) {
    var rail = state.rail;
    if (!rail) return;

    cancelAnimation(state);

    var start = rail.scrollLeft;
    var distance = target - start;

    if (reducedMotion() || Math.abs(distance) < 1) {
      rail.scrollLeft = target;
      return;
    }

    var startedAt = performance.now();
    var duration = 170;

    function tick(now) {
      if (state.interacting || state.rail !== rail) {
        state.animationFrame = 0;
        return;
      }

      var progress = Math.min((now - startedAt) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      rail.scrollLeft = start + distance * eased;

      if (progress < 1) {
        state.animationFrame = window.requestAnimationFrame(tick);
      } else {
        rail.scrollLeft = target;
        state.animationFrame = 0;
      }
    }

    state.animationFrame = window.requestAnimationFrame(tick);
  }

  function syncActiveThumbnail(controls, animate) {
    if (!isMobile() || !controls.isConnected) return;

    var state = getState(controls);
    var rail = bindRail(controls);
    var active = controls.querySelector(THUMB_SELECTOR + "[aria-selected='true']");

    if (!rail || !active) return;

    if (state.interacting) {
      state.pendingSync = true;
      return;
    }

    var railRect = rail.getBoundingClientRect();
    var activeRect = active.getBoundingClientRect();
    var edge = 12;
    var leftLimit = railRect.left + edge;
    var rightLimit = railRect.right - edge;

    if (activeRect.left >= leftLimit && activeRect.right <= rightLimit) return;

    var target = rail.scrollLeft;

    if (activeRect.right > rightLimit) {
      target += activeRect.right - rightLimit + 8;
    } else if (activeRect.left < leftLimit) {
      target -= leftLimit - activeRect.left + 8;
    }

    var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
    target = Math.max(0, Math.min(maximum, target));

    if (animate === false) {
      cancelAnimation(state);
      rail.scrollLeft = target;
    } else {
      animateTo(state, target);
    }
  }

  function scheduleSync(controls, animate) {
    var state = getState(controls);

    if (state.syncFrame) window.cancelAnimationFrame(state.syncFrame);

    state.syncFrame = window.requestAnimationFrame(function () {
      state.syncFrame = 0;
      syncActiveThumbnail(controls, animate);
    });
  }

  function init(controls) {
    if (!controls || initialized.has(controls)) return;
    initialized.add(controls);

    var state = getState(controls);
    bindRail(controls);

    state.observer = new MutationObserver(function (mutations) {
      var rebind = false;
      var activeChanged = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') rebind = true;

        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'aria-selected' &&
          mutation.target.matches(THUMB_SELECTOR) &&
          mutation.target.getAttribute('aria-selected') === 'true'
        ) {
          activeChanged = true;
        }
      });

      if (rebind) bindRail(controls);
      if (activeChanged) scheduleSync(controls, true);
    });

    state.observer.observe(controls, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });

    scheduleSync(controls, false);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(SELECTOR)) init(scope);
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  function cleanup(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(SELECTOR).forEach(function (controls) {
      var state = states.get(controls);
      if (!state) return;

      if (state.observer) state.observer.disconnect();
      if (state.syncFrame) window.cancelAnimationFrame(state.syncFrame);
      unbindRail(controls);
      states.delete(controls);
    });
  }

  function start() {
    scan(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanup(event.target);
  });
})();
